// Stearns site footer rendered in-tree by PageSkeleton (#33285 P3/P5, #33616).
import React from "react";
import { FooterWidgetsIsland as FooterWidgets } from "tsi-common-react/src/components/FooterWidgetsIsland/index";
import { ServiceFooterIsland as ServiceFooter } from "tsi-common-react/src/components/ServiceFooterIsland/index";
import { t } from "ttag";

import { Context } from "@reactivated";

import { NavListSnippet } from "../NavListSnippet";
import { StearnsLogo, StearnsLogoSubtitle } from "./StearnsLogos";

type IFooter = React.ContextType<typeof Context>["chrome"]["footer"];

type IProps = {
    footer: IFooter;
    staticBase: string;
};

export const SiteFooter = (props: IProps): React.JSX.Element => {
    const { footer, staticBase } = props;
    const offersCount = footer.offers_count;
    return (
        <>
            <FooterWidgets
                phone_number={footer.widgets_phone_number}
                show_contact_support={footer.widgets_show_contact_support}
                show_nearby_stores={footer.widgets_show_nearby_stores}
                chat_offline_link={footer.widgets_chat_offline_link}
            />
            <footer className="site-footer">
                <header>
                    <StearnsLogo />
                    <StearnsLogoSubtitle />
                </header>

                <div>
                    {footer.nav_lists.map((navList, i) => (
                        <NavListSnippet
                            key={i}
                            navList={navList}
                            offersCount={offersCount}
                        />
                    ))}
                </div>
                <div>
                    <div className="footer-badges l-capped-width">
                        <div className="footer-badges__item footer-badges__item--a360">
                            <a
                                href="https://allyant.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    className="responsive-img"
                                    src={`${staticBase}img/icons/badge-A360.png`}
                                    alt={t`An Accessible360 badge sharing that we've partnered with an industry-leading ADA vendor who maintains our site is in good standing with accessibility.`}
                                    loading="lazy"
                                    decoding="async"
                                />
                            </a>
                        </div>
                    </div>
                    <div className="social-links">
                        {footer.social_links.map((social, i) => (
                            <a
                                key={i}
                                className="social-link"
                                href={social.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {social.icon_url && (
                                    <img
                                        src={social.icon_url}
                                        alt=""
                                        loading="lazy"
                                        decoding="async"
                                    />
                                )}
                            </a>
                        ))}
                    </div>
                    <div
                        className="legal-text"
                        dangerouslySetInnerHTML={{ __html: footer.legal_text }}
                    />
                </div>
                {footer.show_service_footer && (
                    <ServiceFooter
                        snippets={footer.service_footer_snippets_json}
                        interval={footer.service_footer_interval}
                        loops={footer.service_footer_loops}
                    />
                )}
            </footer>
        </>
    );
};
